import { MOSIDA_API_BASE_URL } from "./mosidaApi";

const baseUrl = MOSIDA_API_BASE_URL;

export async function updateOrderWithPayment(orderId, payload) {
  try {
    const response = await fetch(
      `${baseUrl}/product/order/${orderId}/with-payment`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const raw = await response.text();
    let json = {};
    try {
      json = raw ? JSON.parse(raw) : {};
    } catch {
      json = { message: raw };
    }

    if (!response.ok) {
      const message =
        (typeof json.message === "string" && json.message) ||
        (typeof json.error === "string" && json.error) ||
        `HTTP error! status: ${response.status}`;
      return { success: false, error: message };
    }

    return {
      success: true,
      data: json,
      message: typeof json.message === "string" ? json.message : undefined,
    };
  } catch (error) {
    const message = error instanceof Error ? error.message : "Network error";
    console.error("Update order with payment error:", error);
    return { success: false, error: message };
  }
}

/** Create unpaid orders (status payment-pending) to settle at reception. */
export async function createPayOnReceptionOrder(payload, type = "onsite") {
  try {
    const response = await fetch(
      `${baseUrl}/product/order/pay-on-reception?type=${encodeURIComponent(type)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const raw = await response.text();
    let json = {};
    try {
      json = raw ? JSON.parse(raw) : {};
    } catch {
      json = { message: raw };
    }

    if (!response.ok) {
      const errorObj = json && typeof json === "object" ? json : {};
      const message =
        (typeof errorObj.message === "string" && errorObj.message) ||
        (typeof errorObj.error === "string" && errorObj.error) ||
        `HTTP error! status: ${response.status}`;
      return { success: false, error: message };
    }

    const orders = Array.isArray(json)
      ? json
      : Array.isArray(json?.data)
        ? json.data
        : [];

    return {
      success: true,
      data: orders,
      message: typeof json?.message === "string" ? json.message : undefined,
    };
  } catch (error) {
    const message = error instanceof Error ? error.message : "Network error";
    console.error("Pay on reception order error:", error);
    return { success: false, error: message };
  }
}
